import { AccountStatus, getAccountStatus } from '@hungryroot/customer';
import {
  useNextOrderV3,
  usePollGetOrderNotShuffling,
} from '@hungryroot/orders';
import { useCustomerSelf } from '@hungryroot/use-customer';

export enum AddRemoveAction {
  Add = 'add',
  Remove = 'remove',
}

export function useAddToCartModal(): {
  accountStatus: AccountStatus | undefined;
  orderId: number | undefined;
  isActive: boolean;
  isLoading: boolean;
} {
  const customerQuery = useCustomerSelf();
  const { data: customerData } = customerQuery;
  const useNextOrderResult = useNextOrderV3();
  const { order } = useNextOrderResult;
  const orderId = order?.id;

  const { data: nextCustomizableOrder } = usePollGetOrderNotShuffling({
    params: {
      orderId,
      inventoryDate: order?.inventory_date ?? undefined,
    },
  });

  const accountStatusData = customerData
    ? getAccountStatus(customerData, nextCustomizableOrder)
    : undefined;
  const { accountStatus } = accountStatusData || {};

  return {
    accountStatus,
    orderId,
    isLoading:
      nextCustomizableOrder === undefined || customerData === undefined,
    isActive:
      accountStatus !== undefined && accountStatus !== AccountStatus.Active,
  };
}
